module.exports = __webpack_public_path__ + "e18.no2.5ae41fd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e18.no2.jpg
// module id = gC+s
// module chunks = 0